export enum FeatureFlag {
  PaylocityEnableValidateCompanyId = 'paylocityEnableValidateCompanyId',
  PopOutInstructionsEnabled = 'connectPopOutInstructionsEnabled',
  ShowIncidentsNotification = 'showIncidentsNotification',
  MultiAccountConnectDisableEntitiesScreen = 'multiAccountConnectDisableEntitiesScreen',
  SquarePayrollAcfFallback = 'squarePayrollAcfFallback',
  ConnectCustomIsolvedManualInstructionsPage = 'connectCustomIsolvedManualInstructionsPage',
}
